import { configureStore } from '@reduxjs/toolkit';
import gatewayReducer from './gateway.slice';
import ticketReducer from '../../features/tickets/state/ticket.slice';
import settingsReducer from './settings.slice';

import { api } from './api';

// Endpoint injections: every module below extends the shared `api` slice.
// They are imported for their registration side effect only.
import '../../features/profile/api/user.api';
import '../../features/profile/api/address.api';
import '../../features/profile/api/wallet.api';
import '../../features/profile/api/security.api';
import '../../features/tickets/api/tickets.api';
import '../../features/profile/api/bank.api';
import '../../features/marketing/api/marketing.api';
import '../../features/reports/api/reports.api';
import '../../features/gateways/api/discounts.api';
import 'features/gateways/api/gateways.api';
import 'features/transaction-analytics/api/transaction-analytics.api';
import 'features/customer-behavior-analytics/api/customer-behavior-analytics.api';
import 'features/range-report/api/range-report.api';

const authMiddleware =
    ({ dispatch }: any) =>
    (next: any) =>
    (action: any) => {
        if (action.payload && action.payload.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/';
        }

        return next(action);
    };

// Gateway-scoped queries include their workspace/gateway id in the RTK Query
// argument, so their cache keys are isolated per gateway. Keeping the shared API
// cache intact avoids refetching unrelated data (profile, gateway list, etc.) on
// every switch and makes returning to an already visited gateway instant.

const store = configureStore({
    reducer: {
        gateway: gatewayReducer,
        ticket: ticketReducer,
        settings: settingsReducer,
        [api.reducerPath]: api.reducer,
    },
    devTools: true,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(api.middleware, authMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
